module.exports = "/_next/static/images/CustomerDataFoundationMobile-06a980b50ce7af3a08b68adc951d74c0.webp";